import { useTranslation } from "react-i18next";
// @ts-ignore
import QuestLogo from "@quest/assets/images/questLogo.png";

function MaintenancePage() {
  const { t } = useTranslation("Maintenance");

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center">
      <div className="max-w-2xl w-full text-center">
        <div className="w-[200px] h-[200px] mx-auto">
          <img
            src={QuestLogo}
            alt="Quest Logo"
            className="w-full h-full object-contain"
          />
        </div>
        {/* Icon/Illustration */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-blue-200 rounded-full blur-3xl opacity-50 animate-pulse"></div>
            <div className="relative bg-white rounded-full p-8 shadow-xl">
              <svg
                className="w-24 h-24 text-primary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <h1 className="text-5xl font-bold text-gray-900 mb-4">
          {t("maintenancePageTitle")}
        </h1>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          {t("maintenancePageDescription")}
        </p>

        {/* Additional Info */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-100">
          <p className="text-gray-700 mb-4">
            {t("maintenancePageAdditionalInfo")}
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
            <svg
              className="w-5 h-5 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span>{t("maintenancePageWeWillBeBackSoon")}</span>
          </div>
        </div>

        {/* Footer Note */}
        <p className="mt-8 text-sm text-gray-500">
          {t("maintenancePageThankYouForYourPatience")}
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
